import { Binding } from './type'

const roles: any[] = []
function checkPermission (el: Element, binding: Binding) {
  const { value } = binding

  if (value && value.length > 0) {
    const permissionRoles = value

    const hasPermission = roles.some((role: any) => permissionRoles.includes(role))

    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}

export default {
  mounted (el: Element, binding: any) {
    checkPermission(el, binding)
  },
  update (el: Element, binding: any) {
    checkPermission(el, binding)
  }
}
